// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioButton_root__3jjtt","input":"RadioButton_input__2f5CJ","label":"RadioButton_label__14XAR"};